module.exports = __webpack_public_path__ + "img/boxIconLarge.23b643d2.png";